// extracted by mini-css-extract-plugin
export var fullWidthButton = "_g7-0";